export default __webpack_public_path__ + "static/media/penetratingshot3.b68a85f6.png";